import type { BoggleChallengeBoardDistributionFamilyId } from './types'
import type { BoggleChallengeBoardDistributionDefinition } from './boardDistributionDefinition'
import { moreCommonLetterBoardDistributionDefinition } from './definitions/moreCommonLetter'
import { oopsAllEsBoardDistributionDefinition } from './definitions/oopsAllEs'
import { commonConsonantsOnlyBoardDistributionDefinition } from './definitions/commonConsonantsOnly'
import { noCommonConsonantsBoardDistributionDefinition } from './definitions/noCommonConsonants'
import { vowelParingBoardDistributionDefinition } from './definitions/vowelParing'
import { standardBoardDistributionDefinition } from './definitions/standard'

export const BOGGLE_CHALLENGE_BOARD_DISTRIBUTION_REGISTRY: Record<
  BoggleChallengeBoardDistributionFamilyId,
  BoggleChallengeBoardDistributionDefinition
> = {
  standard: standardBoardDistributionDefinition,
  'more-common-letter': moreCommonLetterBoardDistributionDefinition,
  'oops-all-es': oopsAllEsBoardDistributionDefinition,
  'common-consonants-only': commonConsonantsOnlyBoardDistributionDefinition,
  'no-common-consonants': noCommonConsonantsBoardDistributionDefinition,
  'vowel-paring': vowelParingBoardDistributionDefinition,
}

export function getBoggleChallengeBoardDistributionDefinition(
  familyId: BoggleChallengeBoardDistributionFamilyId,
) {
  return BOGGLE_CHALLENGE_BOARD_DISTRIBUTION_REGISTRY[familyId]
}

export function getBoggleChallengeBoardDistributionDefinitions(
  familyIds: readonly BoggleChallengeBoardDistributionFamilyId[],
) {
  return familyIds.map(familyId => getBoggleChallengeBoardDistributionDefinition(familyId))
}
